import React from 'react';
import { Message, Icon } from 'semantic-ui-react';
import GlassmorphismTheme from '../../styles/glassmorphism';

const CampaignEstimatesDisclaimer: React.FC = () => (
  <Message
    info
    size="small"
    style={{
      marginBottom: 16,
      background: 'rgba(255, 255, 255, 0.45)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255, 255, 255, 0.6)',
      color: GlassmorphismTheme.colors.solid.text,
    }}
  >
    <Icon name="info circle" />
    Os valores exibidos são apenas <strong>estimativas</strong>, não devem ser consideradas como
    verdade absoluta para o recebimento das bonificações.
  </Message>
);

export default CampaignEstimatesDisclaimer;
